module.exports = __webpack_public_path__ + "img/Icon-ExpensesCategories.6df2ec03.svg";